import { errorMessageToastContent } from '@festina-life/components'
import { toast } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'
import { useState } from 'react'

import { useRequiredWorkspaceOperationsContext } from '../../../../workspace/operationsContext'
import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { RebaseWorkspaceBranchConflicts } from './RebaseWorkspaceBranchConflicts'
import { useDetectRebaseWorkspaceConflicts } from './useDetectRebaseWorkspaceConflicts'
import { useRebaseWorkspace } from './useRebaseWorkspace'

export const RebaseWorkspaceButton = () => {
  const translate = useTranslate()
  const { workspaceKey } = useRequiredWorkspaceOperationsContext()
  const [isRebasing, setIsRebasing] = useState(false)
  const rebaseWorkspace = useRebaseWorkspace()
  const rebaseConflicts = useDetectRebaseWorkspaceConflicts({
    forWorkspace: workspaceKey,
    toBranch: workspaceKey.branchKey.name,
  })

  const handleRebaseWorkspace = async (close?: () => void) => {
    setIsRebasing(true)

    try {
      await rebaseWorkspace(workspaceKey)
      close?.()
    } catch (error) {
      toast(errorMessageToastContent({ error, translate }))
    } finally {
      setIsRebasing(false)
    }
  }

  return rebaseConflicts.size ? (
    <Popover>
      {({ close }) => (
        <>
          <PopoverButton as="div">
            <OperationsLoadedButton startIcon="ArrowsUpDown">
              {translate('workspaceDetailsPanel.button.rebase')}
            </OperationsLoadedButton>
          </PopoverButton>
          <ActionsMenuPanel
            anchor={{ to: 'right' }}
            className="max-w-lg! flex flex-col gap-y-4 items-end"
          >
            <RebaseWorkspaceBranchConflicts conflicts={rebaseConflicts} />
            <OperationsLoadedButton
              variant="primary"
              onClick={() => handleRebaseWorkspace(close)}
              isLoading={isRebasing}
            >
              {translate('workspaceDetailsPanel.button.rebase')}
            </OperationsLoadedButton>
          </ActionsMenuPanel>
        </>
      )}
    </Popover>
  ) : (
    <OperationsLoadedButton
      startIcon="ArrowsUpDown"
      onClick={() => handleRebaseWorkspace()}
      isLoading={isRebasing}
    >
      {translate('workspaceDetailsPanel.button.rebase')}
    </OperationsLoadedButton>
  )
}
